import { EventTracking, EventType } from '@app/tracking';
export default class LinkedInInsight {
    constructor(partnerId, leadConversionId, scriptPath = 'https://snap.licdn.com/li.lms-analytics/insight.min.js') {
        this.partnerId = partnerId;
        this.leadConversionId = leadConversionId;
        window._linkedin_partner_id = partnerId;
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
        let scriptTag = document.createElement("script");
        scriptTag.async = true;
        scriptTag.src = scriptPath;
        document.body.appendChild(scriptTag);
        if (window.laravelDebug) {
            console.log(`✅ LinkedIn Tracking initialized for "${partnerId}"`);
        }
        this.registerListeners();
    }
    registerListeners() {
        // Form success
        EventTracking.listen(EventType.FormSuccess, ({ form }) => {
            this.generatePixel(`https://px.ads.linkedin.com/collect/?pid=${this.partnerId}&conversionId=${this.leadConversionId}&fmt=gif`);
        });
    }
    generatePixel(src) {
        let pixel = document.createElement("img");
        pixel.height = 1;
        pixel.width = 1;
        pixel.style.display = 'none';
        pixel.src = src;
    }
}
